@if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <div [formGroup]="getControl('data')">
    <div class="d-flex align-items-center">
      <h1 class="person-label">{{ "HEAD_OF_HOUSEHOLD" | globalTranslate }}:</h1>
      <span class="ps-2 pb-1">{{ fullName }}</span>
    </div>
    @if (user !== 'RP') {
    <p class="static-text">{{ "HOH_MORE_INFO" | globalTranslate }}</p>
    } @if (appType === 'PRG' || appType === 'HPE' || this.appType === 'BCC') {
    <div>
      <h2 class="section-header">{{ "APPLICATION_DATE" | globalTranslate }}</h2>
      <hr />
      <div class="row g-3">
        <div class="col-6 col-md-6">
          <nh-field
            id="hh_dateOfApplication"
            label="{{ 'DATE_OF_APPLICATION' | globalTranslate }}"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                class="form-control"
                name="dateOfApplication"
                formControlName="dateOfApplication"
                [attr.aria-label]="'DATE_OF_APPLICATION' | globalTranslate"
                placeholder="mm/dd/yyyy"
                [minDate]="minimumDate"
                [maxDate]="today"
                bsDatepicker
                nh
                required
              />
            </nh-datepicker>
          </nh-field>
        </div>
      </div>
    </div>
    }
    <h2 class="section-header">{{ "HOH_DEMOGRAPHICS" | globalTranslate }}</h2>
    <hr />

    <nh-name-address
      [addressname]="'hh_casehead'"
      [namePopup]="true"
      [personalName]="getControl('data.casehead')"
      [isAssistingPerson]="false"
      [tables]="tables"
    >
    </nh-name-address>
    <br />

    <section formGroupName="languagePreference">
      <nh-field
        id="hh_primaryLanguage"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'HOH_LANG_PREFERENCE' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="primaryLanguage"
          [items]="tables.PRIMARYLANGUAGE"
          [attr.aria-label]="'HOH_LANG_PREFERENCE' | globalTranslate"
          formControlName="primaryLanguage"
        ></select>
      </nh-field>

      @if (isEnabled('data.languagePreference.otherLanguageName')) {
      <nh-field
        id="hh_otherLanguageName"
        name="otherLanguageName"
        label="{{ 'IF_OTHER_LANG' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          name="otherLanguageName"
          class="form-control"
          [attr.aria-label]="'IF_OTHER_LANG' | globalTranslate"
          formControlName="otherLanguageName"
          maxlength="50"
        />
      </nh-field>
      }

      <nh-field
        id="hh_letterLanguage"
        name="letterLanguage"
        label="{{ 'LETTER_PREF_LANG' | globalTranslate }}"
        [col9]="true"
      >
        @if (user !== 'RP') {
        <nh-popover
          style="padding-left: 1px"
          content="{{ 'LANG_POPUP' | globalTranslate }}"
        ></nh-popover>
        }
        <select
          nhTranslate
          name="letterLanguage"
          [items]="tables.WRITTENLANGUAGE"
          [attr.aria-label]="'LETTER_PREF_LANG' | globalTranslate"
          formControlName="letterLanguage"
          required
        ></select>
      </nh-field>
    </section>

    <!-- <nh-field *ngIf="this.isMedicAidApp" name="letterLanguage" label="{{'LETTER_PREF_LANG' | globalTranslate}}"> -->

    <nh-field
      id="hh_homeless"
      name="homeless"
      label="{{ 'ARE_YOU_HOMELESS' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="homeless"
        [items]="getLangData(tables.YESNO)"
        formControlName="homeless"
        [attr.aria-label]="'ARE_YOU_HOMELESS' | globalTranslate"
        (change)="homelessOnChange($event)"
        required
      ></select>
    </nh-field>

    <nh-field
      id="hh_safeAtHome"
      [mandatory]="false"
      [attr.aria-required]="false"
      name="safeAtHome"
      [label]="
        ('MAIL_THROUGH_SAFEATHOME_PART1' | globalTranslate) +
        ('SAFE_AT_HOME_PROGRAM_NAME' | globalTranslate) +
        ('MAIL_THROUGH_SAFEATHOME_PART2' | globalTranslate)
      "
      [col9]="true"
    >
      <div class="nh-tooltip" [class.tooltip-expanded]="isTooltipExpanded">
        <span
          tabindex="0"
          role="button"
          [attr.aria-label]="'SAFEATHOME_INFO_ARIA' | globalTranslate"
          [attr.aria-expanded]="isTooltipExpanded"
          [attr.aria-describedby]="
            isTooltipExpanded ? 'safeAtHomeTooltip' : null
          "
          (click)="onTooltipClick($event)"
          (keydown)="onTooltipButtonKeydown($event)"
        >
          <span class="toolTip">
            <img
              [src]="'assets/images/Icons/tool-tip-icon.svg'"
              alt=""
              aria-hidden="true"
          /></span>
        </span>
        <p
          id="safeAtHomeTooltip"
          class="tooltiptext"
          role="region"
          [attr.aria-hidden]="!isTooltipExpanded"
          placement="auto"
          (keydown)="onTooltipContentKeydown($event)"
        >
          <span [innerHTML]="'SAFEATHOME_POPOVER' | globalTranslate"></span>
          <b
            ><a href="https://sos.tn.gov/SafeAtHome" target="_blank"
              >sos.tn.gov/SafeAtHome.</a
            ></b
          >
        </p>
      </div>
      <select
        nhTranslate
        name="safeAtHome"
        [items]="getLangData(tables.YESNO)"
        [attr.aria-label]="
          ('MAIL_THROUGH_SAFEATHOME_PART1' | globalTranslate) +
          ('SAFE_AT_HOME_PROGRAM_NAME' | globalTranslate) +
          ('MAIL_THROUGH_SAFEATHOME_PART2' | globalTranslate)
        "
        formControlName="sahPrgSw"
        (change)="safeAtHomeOnChange($event)"
      ></select>
    </nh-field>

    @if (isY('data.sahPrgSw')) {
    <nh-field
      id="hh_mailId"
      label="{{ 'SAFEATHOME_MAILID' | globalTranslate }}"
      class="label-section"
    >
      <div class="hint ms-2">
        {{ "SAFEATHOME_MAILID_HELPTEXT" | globalTranslate }}
      </div>
      <input
        (input)="onInput($event)"
        (keypress)="omit_special_char($event)"
        (focusout)="onFocusOut()"
        type="text"
        name="sahMailId"
        [attr.aria-label]="'SAFEATHOME_MAILID' | globalTranslate"
        placeholder="#XXXX-X"
        prefix="#"
        [mask]="sahmask"
        class="form-control"
        formControlName="sahMailId"
        maxlength="50"
      />
      @if (isInvalidSahMailId) {
      <span class="form-text invalid-name d-block">{{
        "INVALID_SAHID" | globalTranslate
      }}</span>
      }
    </nh-field>
    }
    <br />

    @if (isY('data.sahPrgSw')) {
    <nh-field
      id="hh_safeAtHomeCounty"
      name="sahCountyCd"
      label="{{ 'SAFEATHOME_COUNTY' | globalTranslate }}"
    >
      <select
        nhTranslate
        name="sahCountyCd"
        [items]="tables.COUNTY"
        [attr.aria-label]="'SAFEATHOME_COUNTY' | globalTranslate"
        formControlName="sahCountyCd"
      ></select>
    </nh-field>
    } @if (isN('data.homeless') && !isY('data.sahPrgSw')) {
    <div>
      <h2 class="section-header">{{ "HOH_HOME_ADDRESS" | globalTranslate }}</h2>
      <hr />
      @if (isEnabled('data.physicalAddress.addressFormat') &&
      !isY('data.sahPrgSw') ) {
      <div [formGroup]="getControl('data.physicalAddress')">
        @if (isEnabled('data.physicalAddress.addressFormat')&&
        !isY('data.sahPrgSw')) {
        <div>
          <nh-field
            id="hh_physical_addressFormat"
            name="addressFormat"
            label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
            class="label-section"
          >
            <nh-popover
              class="ps-1"
              content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
            ></nh-popover>
            <select
              nh
              name="addressFormat"
              [items]="tables.ADDRESSFORMATTYPES"
              [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
              formControlName="addressFormat"
              required
            ></select>
          </nh-field>
        </div>
        }
        <nh-name-address
          [addressname]="'hh_physicalAddress'"
          [addressFormat]="getControl('data.physicalAddress.addressFormat')"
          [address]="getControl('data.physicalAddress.address')"
          [isAssistingPerson]="false"
          [tables]="tables"
        >
        </nh-name-address
        ><br />
      </div>
      }
    </div>
    } @if (!isY('data.sahPrgSw')) {
    <div>
      <h2 class="section-header">
        {{ "HOH_MAILING_ADDRESS" | globalTranslate }}
      </h2>
      <hr />
      <div [formGroup]="getControl('extras.helpers')">
        @if (isEnabled('extras.helpers.addMailingInfo') &&
        !isY('data.sahPrgSw')) {
        <nh-field
          id="hh_addMailingInfo"
          label="{{ 'IS_MAILING_ADDRESS_SAME' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="addMailingInfo"
            [items]="tables.YESNO"
            formControlName="addMailingInfo"
            [attr.aria-label]="'HOH_MAILING_ADDRESS' | globalTranslate"
            required
          ></select>
        </nh-field>
        }
      </div>
      @if (isY('data.homeless') && !isY('data.sahPrgSw')) {
      <div class="static-text">
        <p>{{ "HOMELESS_CONTENT_1" | globalTranslate }}</p>
        <p>{{ "HOMELESS_CONTENT_2" | globalTranslate }}</p>
      </div>
      } @if (isEnabled('data.mailingAddress.addressFormat')) {
      <section [formGroup]="getControl('data.mailingAddress')">
        @if (isEnabled('data.mailingAddress.addressFormat')) {
        <div>
          <nh-field
            id="hh_mailing_addressFormat"
            name="addressFormat"
            label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
            class="label-section"
          >
            <nh-popover
              class="ps-1"
              content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
            ></nh-popover>
            <select
              nh
              name="addressFormat"
              [items]="tables.ADDRESSFORMATTYPES"
              [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
              formControlName="addressFormat"
              required
            ></select>
          </nh-field>
        </div>
        }
        <nh-name-address
          [addressname]="'hh_mailingAddress'"
          [addressFormat]="getControl('data.mailingAddress.addressFormat')"
          [address]="getControl('data.mailingAddress.address')"
          [showPopup]="toolTip"
          [tables]="tables"
        ></nh-name-address>
      </section>
      }
    </div>
    }

    <h2 class="section-header">{{ "HOH_CONTACT_INFO" | globalTranslate }}</h2>
    <hr />

    @if (isDateOfApplicationEnabled()) {
    <nh-field
      id="hh_applicationDt"
      label="{{ 'DATE_OF_APPLICATION' | globalTranslate }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          class="form-control"
          name="applicationDt"
          formControlName="applicationDt"
          [attr.aria-label]="'DATE_OF_APPLICATION' | globalTranslate"
          placeholder="mm/dd/yyyy"
          [minDate]="minimumDate"
          [maxDate]="today"
          bsDatepicker
          nh
        />
      </nh-datepicker>
    </nh-field>
    }

    <section formGroupName="physicalAddress">
      @if (isEnabled('data.physicalAddress.applicationSource') && (isAhsAfb) ) {
      <nh-field
        id="hh_applicationSource"
        label="{{ 'APPLICATION_SOURCE' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="applicationSource"
          [items]="tables.APRNSOURCE"
          [attr.aria-label]="'APPLICATION_SOURCE' | globalTranslate"
          formControlName="applicationSource"
        ></select>
      </nh-field>
      } @if (isEnabled('data.physicalAddress.applicationSource') && (isAhsRmc) )
      {
      <nh-field
        id="hh_applicationSource"
        label="{{ 'CHANGEREQUEST_SOURCE' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="applicationSource"
          [items]="tables.APRNSOURCE"
          [attr.aria-label]="'CHANGEREQUEST_SOURCE' | globalTranslate"
          formControlName="applicationSource"
        ></select>
      </nh-field>
      } @if (isEnabled('data.physicalAddress.applicationSource') && (isAhsRmb) )
      {
      <nh-field
        id="hh_applicationSource"
        label="{{ 'RENEWAL_SOURCE' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="applicationSource"
          [items]="tables.APRNSOURCE"
          [attr.aria-label]="'RENEWAL_SOURCE' | globalTranslate"
          formControlName="applicationSource"
        ></select>
      </nh-field>
      }
      <nh-contact-phones
        [contactPhoneName]="'hh_physicalAddress_contactPhones'"
        [phoneNumbers]="getControl('data.physicalAddress.contactPhones')"
      ></nh-contact-phones>

      @if (isEnabled('data.physicalAddress.bestTime')) {
      <nh-field
        id="hh_bestTime"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'BEST_TIME_TO_CALL' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="bestTime"
          [items]="tables.CONTACTTIME"
          [attr.aria-label]="'BEST_TIME_TO_CALL' | globalTranslate"
          formControlName="bestTime"
        ></select>
      </nh-field>
      }
    </section>

    @if (appType === 'PRG' || appType === 'HPE' || this.appType === 'BCC') {
    <nh-field
      id="hh_healthPlan"
      label="{{ 'HEALTH_PLAN_PREFERENCE' | globalTranslate }}"
      [mandatory]="false"
      [attr.aria-required]="false"
    >
      @if (!showWellpoint) {
      <select
        nhTranslate
        name="healthPlan"
        [items]="tables.MCONAME"
        [attr.aria-label]="'HEALTH_PLAN_PREFERENCE' | globalTranslate"
        formControlName="healthPlan"
      ></select>
      } @if (showWellpoint) {
      <select
        nhTranslate
        name="healthPlan"
        [items]="tables.MCONAME_UBW"
        [attr.aria-label]="'HEALTH_PLAN_PREFERENCE' | globalTranslate"
        formControlName="healthPlan"
      ></select>
      }
    </nh-field>
    }
    <br />

    <!-- Header and Label only for FC and FRM -->
    @if ((user == 'RP' && (appType === 'AFB' || isFinReassessment))) {
    <div>
      <h2 class="section-header">Assisting Person</h2>
      <hr />
      <p>
        An Assisting Person can be someone who is helping you complete this
        application, or it can be someone that, with your permission, can make
        decisions and talk to us on behalf of your household.
      </p>
      <br />
      <p>
        If you want an Assisting Person to help you, you can tell us what you
        want your Assisting Person to help with.
      </p>
    </div>
    }

    <!-- MEMBER PORTAL SEQUENCING -->

    <!--
                  "assistingOnBehalf - Assis/Self"
                  "addAssistingPersonToApp - Yes/No" -->

    <!-- FIRST QUESTION FOR *MP* AFB, RMC, RMB,  also for AHS AFB, RMB, RMC-->
    @if ((user !== 'RP' || isAhsRmbOrRmc || ppViewTccHoHrmbrmc) ) {
    <nh-field
      id="hh_assistingOnBehalf"
      label="{{ 'ASSISTING_ON_BEHALF_1' | globalTranslate }} {{
        appKey | globalTranslate
      }} {{ 'ASSISTING_ON_BEHALF_2' | globalTranslate }} {{
        appKey | globalTranslate
      }} {{ 'ASSISTING_ON_BEHALF_3' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_1' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="assistingOnBehalf"
        [items]="tables.MPASSTPER"
        [attr.aria-label]="
          ('ASSISTING_ON_BEHALF_1' | globalTranslate) +
          '' +
          (appKey | globalTranslate) +
          ('ASSISTING_ON_BEHALF_3' | globalTranslate)
        "
        formControlName="assistingOnBehalf"
        (change)="onAssistingPersonBehalfSelected($event)"
      ></select>
    </nh-field>
    }

    <!-- SECOND QUESTION FOR *MP* AFB RMB RMC,  also for AHS AFB, RMB, RMC-->
    @if (isEnabled('data.addAssistingPersonToApp') &&
    getValue('data.assistingOnBehalf').code === 'S' && (user !== 'RP' ||
    isAhsRmbOrRmc || ppViewTccHoHrmbrmc)) {
    <nh-field
      id="hh_addAssistingPersonToApp"
      label="{{ 'ADD_TO_APPLICATION' | globalTranslate }} {{
        appKey | globalTranslate
      }}?"
      [labelSize]="false"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_2' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="addAssistingPersonToApp"
        [items]="tables.YESNO"
        [attr.aria-label]="
          ('ADD_TO_APPLICATION' | globalTranslate) +
          '' +
          (appKey | globalTranslate)
        "
        [formControl]="getControl('data.addAssistingPersonToApp')"
        (change)="onAssistingPersonSelected($event)"
      ></select>
    </nh-field>
    }

    <!-- PARTNER PORTAL SEQUENCING -->

    <!-- FRM
                  "ppAddAssistingPersonToApp - Yes/No"
                  "ppAssistingOnBehalf - Assis/Self"

                  PP FC
                  "ppAddAssistingPersonToApp - Yes/No"
                  "ppAssistingOnBehalf - Yes/No" -->

    <!-- FIRST QUESTION FOR FIN RES -->

    @if (isEnabled('data.ppAddAssistingPersonToApp') && (user === 'RP' &&
    this.isFinReassessment)) {
    <nh-field
      id="hh_ppAddAssistingPersonToApp"
      label="Does {{ fullName }} want to add {{
        partnerName
      }} as an Assisting Person on this reassessment?"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_2' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="ppAddAssistingPersonToApp"
        [items]="tables.YESNO"
        [attr.aria-label]="
          'Does' +
          '' +
          fullName +
          '' +
          'want to add' +
          '' +
          partnerName +
          '' +
          'as an Assisting Person on this reassessment?'
        "
        [formControl]="getControl('data.ppAddAssistingPersonToApp')"
        (change)="ppOnAssistingPersonSelected($event)"
      ></select>
    </nh-field>
    }

    <!-- Check the onchange function -->

    <!-- FIRST QUESTION FOR FULL COVERAGE-->

    @if (isEnabled('data.ppAddAssistingPersonToApp') && (user === 'RP' &&
    appType === 'AFB' && !isAHS)) {
    <nh-field
      id="hh_ppAddAssistingPersonToApp"
      label="Does {{ fullName }} want to add {{
        partnerName
      }} as an Assisting Person on this application?"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_2' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="ppAddAssistingPersonToApp"
        [items]="tables.YESNO"
        [attr.aria-label]="
          'Does' +
          '' +
          fullName +
          '' +
          'want to add' +
          '' +
          partnerName +
          '' +
          'as an Assisting Person on this application'
        "
        [formControl]="getControl('data.ppAddAssistingPersonToApp')"
        (change)="ppOnAssistingPersonSelected($event)"
      ></select>
    </nh-field>
    }

    <!-- Check the onchange function -->

    <!-- static text -->
    @if (user === 'RP' && (appType === 'AFB' || isFinReassessment) && !isAHS &&
    isY('data.ppAddAssistingPersonToApp')) {
    <div
      class="ps-2 form-check-label"
      [innerHTML]="'REPRESENTATIVE_ORGANIZATION' | globalTranslate"
    ></div>
    } @if (user === 'RP' && (appType === 'AFB' || isFinReassessment) && !isAHS
    && isY('data.ppAddAssistingPersonToApp')) {
    <ul class="pb-4 list-inline form-check-label">
      <li>{{ "REPRESENTATIVE_ORGANIZATION_1" | globalTranslate }}</li>
      <li>{{ "REPRESENTATIVE_ORGANIZATION_2" | globalTranslate }}</li>
      <li>{{ "REPRESENTATIVE_ORGANIZATION_3" | globalTranslate }}</li>
      <li>{{ "REPRESENTATIVE_ORGANIZATION_4" | globalTranslate }}</li>
      <li>{{ "REPRESENTATIVE_ORGANIZATION_5" | globalTranslate }}</li>
    </ul>
    }

    <!-- SECOND QUESTION FOR FULL COVERAGE -->

    @if (isEnabled('data.ppAssistingOnBehalf') &&
    (isN('data.ppAddAssistingPersonToApp')) && (user === 'RP' && appType ===
    'AFB' && !isAHS)) {
    <nh-field
      id="hh_ppAssistingOnBehalf"
      label="Does {{ fullName }} want to list an Assisting Person?"
      class="label-section"
    >
      <div class="hint ms-2">
        (This would be someone other than {{ partnerName }})
      </div>
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_1' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="ppAssistingOnBehalf"
        [items]="tables.YESNO"
        [attr.aria-label]="
          'Does' + '' + fullName + '' + 'want to list an Assisting Person?'
        "
        formControlName="ppAssistingOnBehalf"
        (change)="ppOnAssistingPersonBehalfSelectedFCFRM($event)"
      ></select>
    </nh-field>
    }

    <!-- SECOND QUESTION FOR FIN RES -->

    @if ((user === 'RP' && this.isFinReassessment &&
    (isN('data.ppAddAssistingPersonToApp')))) {
    <nh-field
      id="hh_ppAssistingOnBehalf"
      label="Does {{ fullName }} want to list an Assisting Person?"
      class="label-section"
    >
      <div class="hint ms-2">
        (This would be someone other than {{ partnerName }})
      </div>
      <nh-popover
        class="ps-1"
        field-label
        content="{{ 'ASSISTING_PERSON_POPOVER_1' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="ppAssistingOnBehalf"
        [items]="tables.YESNO"
        [attr.aria-label]="
          'Does' + '' + fullName + '' + 'wanttolistanAssistingPerson?'
        "
        formControlName="ppAssistingOnBehalf"
        (change)="ppOnAssistingPersonBehalfSelectedFCFRM($event)"
      ></select>
    </nh-field>
    } @if ((isY('data.addAssistingPersonToApp') ||
    getValue('data.assistingOnBehalf').value === 'Assisting Person' ||
    getValue('data.assistingOnBehalf').value === 'Persona que Ayuda' ||
    isY('data.ppAddAssistingPersonToApp') || isY('data.ppAssistingOnBehalf'))) {
    <section [formGroup]="getControl('data.assistingPerson')">
      <div>
        @if ((isY('data.addAssistingPersonToApp') ||
        getValue('data.assistingOnBehalf').value === 'Assisting Person' ||
        getValue('data.assistingOnBehalf').value === 'Persona que Ayuda' ||
        isY('data.ppAddAssistingPersonToApp') ||
        isY('data.ppAssistingOnBehalf'))) {
        <h2 class="section-header">
          {{ "ASSISTING_PERSON_INFORMATION" | globalTranslate }}
        </h2>
        }
        <!-- check heading for FRM and PP FC -->
        <hr />
        <!-- Help Duration - First Question 'NO' or 'SELF'. Second question - 'Yes' -->
        <!-- Help Duration MP, ,  also for AHS AFB, RMB, RMC--->
        @if (( isEnabled('data.assistingPerson.helpDuration') &&
        ((getValue('data.assistingOnBehalf').code === 'S') &&
        isY('data.addAssistingPersonToApp')) && (user !== 'RP' || isAhsRmbOrRmc
        || ppViewTccHoHrmbrmc))) {
        <nh-field
          id="hh_helpDuration"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ASSIST_PERSON_HELP_DURATION' | globalTranslate }}"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            field-label
            content="{{ 'ASSISTING_PERSON_TITLE' | globalTranslate }}"
          ></nh-popover>
          <div class="hint" style="padding-bottom: 6px">
            {{ "HELP_DURATION_TEXT" | globalTranslate }}
          </div>
          <select
            nhTranslate
            name="helpDuration"
            [items]="tables.AUTHREPTIME"
            [attr.aria-label]="'ASSIST_PERSON_HELP_DURATION' | globalTranslate"
            formControlName="helpDuration"
          ></select>
        </nh-field>
        }
        <!-- Help Duration PP FC -->
        @if ((isEnabled('data.assistingPerson.helpDuration') && ((user === 'RP'
        && appType === 'AFB' && !isAHS) &&
        (isY('data.ppAddAssistingPersonToApp') ||
        isY('data.ppAssistingOnBehalf'))))) {
        <nh-field
          id="hh_helpDuration"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ASSIST_PERSON_HELP_DURATION' | globalTranslate }}"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            field-label
            content="Please re-enter any previously provided signature if you change the answer to this question."
          ></nh-popover>
          <div class="hint" style="padding-bottom: 6px">
            {{ "HELP_DURATION_TEXT" | globalTranslate }}
          </div>
          <select
            nhTranslate
            name="helpDuration"
            [items]="tables.AUTHREPTIME"
            [attr.aria-label]="'ASSIST_PERSON_HELP_DURATION' | globalTranslate"
            formControlName="helpDuration"
          ></select>
        </nh-field>
        }
        <!-- Help Duration PP FRM -->
        @if ( isEnabled('data.assistingPerson.helpDuration') && ((user === 'RP'
        && this.isFinReassessment) && ((isY('data.ppAddAssistingPersonToApp'))
        || isY('data.ppAssistingOnBehalf')))) {
        <nh-field
          id="hh_helpDuration"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ASSIST_PERSON_HELP_DURATION' | globalTranslate }}"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            field-label
            content="Please re-enter any previously provided signature if you change the answer to this question."
          ></nh-popover>
          <div class="hint" style="padding-bottom: 6px">
            {{ "HELP_DURATION_TEXT" | globalTranslate }}
          </div>
          <select
            nhTranslate
            name="helpDuration"
            [items]="tables.AUTHREPTIME"
            [attr.aria-label]="'ASSIST_PERSON_HELP_DURATION' | globalTranslate"
            formControlName="helpDuration"
          ></select>
        </nh-field>
        }
        <!-- RelationShip Question - First or Second has to be 'YES' -->
        <!-- Only for MP , also for AHS AFB, RMB,RMC -- RelationShip Question -->
        @if ((isY('data.addAssistingPersonToApp') ||
        (getValue('data.assistingOnBehalf').value === 'Assisting Person' ||
        getValue('data.assistingOnBehalf').value === 'Persona que Ayuda')) &&
        (user !== 'RP'|| isAhsRmbOrRmc || ppViewTccHoHrmbrmc )) {
        <div>
          @if (isEnabled('data.assistingPerson.relationship')) {
          <nh-field
            id="hh_relationship"
            label="{{ 'WHAT_IS_YOUR_RELATINSHIP_TO' | globalTranslate }} {{
              this.fullName
            }}?"
            class="label-section"
          >
            <select
              nhTranslate
              name="relationship"
              [items]="tables.AUTHREPRELATIONSHIP"
              (change)="
                onChange(
                  getValue('data.assistingPerson.relationship'),
                  'assistingPersonRelationship'
                )
              "
              [attr.aria-label]="
                ('WHAT_IS_YOUR_RELATINSHIP_TO' | globalTranslate) +
                '' +
                this.fullName
              "
              formControlName="relationship"
            ></select>
          </nh-field>
          }
          <div class="ps-1 pt-1 hover-red">
            <a
              tabindex="0"
              class="btn btn-link hover-red"
              (click)="showAssistPerson()"
            >
              <span class="pe-2">{{
                "ASSIST_PERSON_RELATIONSHIP_LINK" | globalTranslate
              }}</span>
              <span
                ><i class="fa fa-external-link" aria-hidden="true"></i
              ></span>
            </a>
          </div>
        </div>
        }
        <!-- PP FRM- RelationShip Question -->
        @if ((isY('data.ppAddAssistingPersonToApp') ||
        isY('data.ppAssistingOnBehalf')) && (user === 'RP' && isFinReassessment
        )) {
        <div>
          @if (isEnabled('data.assistingPerson.relationship')) {
          <nh-field
            id="hh_relationship"
            label="{{ 'WHAT_IS_YOUR_RELATINSHIP_TO' | globalTranslate }} {{
              this.fullName
            }}?"
            class="label-section"
          >
            <select
              nhTranslate
              name="relationship"
              [items]="tables.AUTHREPRELATIONSHIP"
              (change)="
                onChange(
                  getValue('data.assistingPerson.relationship'),
                  'assistingPersonRelationship'
                )
              "
              [attr.aria-label]="
                ('WHAT_IS_YOUR_RELATINSHIP_TO' | globalTranslate) +
                '' +
                this.fullName
              "
              formControlName="relationship"
            ></select>
          </nh-field>
          }
          <div class="row ps-1 pt-1 hover-red">
            <a
              tabindex="0"
              class="btn btn-link hover-red"
              (click)="showAssistPerson()"
            >
              <span class="pe-2">{{
                "ASSIST_PERSON_RELATIONSHIP_LINK" | globalTranslate
              }}</span>
              <span
                ><i class="fa fa-external-link" aria-hidden="true"></i
              ></span>
            </a>
          </div>
        </div>
        }
        <!-- PP FC- RelationShip Question -->
        @if ((isY('data.ppAddAssistingPersonToApp') ||
        isY('data.ppAssistingOnBehalf')) && (user === 'RP' && appType === 'AFB'
        && !isAHS)) {
        <div>
          @if (isEnabled('data.assistingPerson.relationship')) {
          <nh-field
            id="hh_relationship"
            label="What is this person's relationship to the applicant?"
            class="label-section"
          >
            <select
              nhTranslate
              name="relationship"
              [items]="tables.AUTHREPRELATIONSHIP"
              [attr.aria-label]="'personsrelationshiptotheapplicant'"
              formControlName="relationship"
              (change)="onChange(getValue('data.assistingPerson.relationship'))"
            ></select>
          </nh-field>
          }
          <div class="row ps-1 pt-1 hover-red">
            <a
              tabindex="0"
              class="btn btn-link hover-red"
              (click)="showAssistPerson()"
            >
              <span class="pe-2">{{
                "ASSIST_PERSON_RELATIONSHIP_LINK" | globalTranslate
              }}</span>
              <span
                ><i class="fa fa-external-link" aria-hidden="true"></i
              ></span>
            </a>
          </div>
        </div>
        }
        <nh-alert
          type="warning"
          [isOpen]="
            getValue('data.assistingPerson.relationship').code === 'CO' ||
            getValue('data.assistingPerson.relationship').code === 'PA' ||
            getValue('data.assistingPerson.relationship').code === 'LG'
          "
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{
                "RELATIONSHIP_WARNING"
                  | translate: getValue("data.assistingPerson.relationship")
                  | globalTranslate
              }}</span>
            </div>
          </div>
        </nh-alert>
      </div>
      <section class="pt-3">
        <nh-alert type="warning" [isOpen]="validateAssistingPersonName()">
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{ "ASSISTING_PERSON_ERROR" | globalTranslate }}</span>
            </div>
          </div>
        </nh-alert>
        @if (isEnabled('data.assistingPerson.name')) {
        <div>
          <h2 class="section-header">
            {{ "ASSISTING_PERSON_NAME" | globalTranslate }}
          </h2>
          <hr />
          <p class="mb-custom">{{ "ASSISTING_PERSON_NAME_MSG" | globalTranslate }}</p>
          <nh-name-address
            [addressname]="'hh_name'"
            [isAssistingPerson]="true"
            [personalName]="getControl('data.assistingPerson.name')"
            [tables]="tables"
          ></nh-name-address>
          <br />
        </div>
        } @if (isEnabled('data.assistingPerson.organizationName')) {
        <nh-field
          id="hh_organizationName"
          name="organizationName"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ORG_NAME_IF' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="organizationName"
            class="form-control"
            [attr.aria-label]="'ORG_NAME_IF' | globalTranslate"
            formControlName="organizationName"
            maxlength="256"
          />
        </nh-field>
        } @if (isEnabled('data.assistingPerson.idNumber')) {
        <nh-field
          id="hh_idNumber"
          name="idNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ID_NUMBER_IF' | globalTranslate }}"
          mask="9999999999"
          class="label-section"
        >
          <input
            type="text"
            name="idNumber"
            class="form-control"
            [attr.aria-label]="'ID_NUMBER_IF' | globalTranslate"
            formControlName="idNumber"
            maxlength="20"
          />
        </nh-field>
        } @if (isEnabled('data.assistingPerson.address')) {
        <div>
          <h2 class="section-header">
            {{ "ASSISTING_PERSON_ADDRESS" | globalTranslate }}
          </h2>
          <hr />
          <div>
            <nh-field
              id="hh_assisting_addressFormat"
              name="addressFormat"
              label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
              class="label-section"
            >
              <nh-popover
                class="ps-1"
                content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
              ></nh-popover>
              <select
                nh
                name="addressFormat"
                [items]="tables.ADDRESSFORMATTYPES"
                [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
                formControlName="addressFormat"
                required
              ></select>
            </nh-field>
          </div>
          <nh-name-address
            [addressname]="'hh_assisting_addressFormat'"
            [addressFormat]="getControl('data.assistingPerson.addressFormat')"
            [address]="getControl('data.assistingPerson.address')"
            [showPopup]="toolTip"
            [isAssistingPerson]="true"
            [tables]="tables"
          >
          </nh-name-address>
          <br />
        </div>
        }
        <h2 class="section-header">
            {{ "ASSISTING_PERSON_CONTACT" | globalTranslate }}
        </h2>
        <hr />
        @if (isEnabled('data.assistingPerson.email')) {
        <div>
          <nh-field
            id="hh_email"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'EMAIL_ADDRESS' | globalTranslate }}:"
            class="label-section"
          >
            <input
              type="email"
              name="email"
              class="form-control"
              [attr.aria-label]="'EMAIL_ADDRESS' | globalTranslate"
              formControlName="email"
              maxlength="63"
            />
          </nh-field>
        </div>
        } @if (isEnabled('data.assistingPerson.bestTime')) {
        <nh-field
          id="hh_bestTime"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'BEST_TIME_TO_CALL' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="bestTime"
            [items]="tables.CONTACTTIME"
            [attr.aria-label]="'BEST_TIME_TO_CALL' | globalTranslate"
            formControlName="bestTime"
          ></select>
        </nh-field>
        } @if (isEnabled('data.assistingPerson.contactPhones')) {
        <nh-contact-phones
          [contactPhoneName]="'hh_assistingPerson_contactPhones'"
          [phoneNumbers]="getControl('data.assistingPerson.contactPhones')"
        ></nh-contact-phones>
        }
      </section>
      <br />
    </section>
    }
    <div>
      <input id="hh_hiddenField" type="hidden" formControlName="hiddenField" />
    </div>
   @if (getValue('data.assistingPerson.relationship').code === 'AR' ||
      getValue('data.assistingPerson.relationship').code === 'OH') {
      <div>
        <h2 class="section-header">
          {{ "ASSIST_PERSON_RESP" | globalTranslate }}
        </h2>
        <hr />
        <label for="Responsibilities Warning" class="mb-1 label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          ><span class="visually-hidden">{{
            "required" | globalTranslate
          }}</span
          >{{ "ASSIST_PERSON_RESP_WARN" | globalTranslate }}:</label
        >
        <div
          [formGroup]="getControl('data.assistingPerson.responsibilities')"
          class="form-check pb-2 pb-md-1"
        >
          <nh-checkbox
            name="applicantBehalf"
            [control]="
              getControl(
                'data.assistingPerson.responsibilities.applicantBehalf'
              )
            "
            checkedValue="A"
            [disabled]="
              getValue(
                'data.assistingPerson.responsibilities.submitRenewal'
              ) === 'S'
            "
            label="{{ applicantBehalf1 | globalTranslate }} {{
              appKey2 | globalTranslate
            }} {{ 'APPLICANT_BEHALF_2' | globalTranslate }}"
            class="label-section"
            (change)="onChange($event, 'A')"
          >
          </nh-checkbox>
          @if (appKey === 'CHANGE_TEXT') {
          <div>
            <nh-checkbox
              name="submitRenewal"
              [control]="
                getControl(
                  'data.assistingPerson.responsibilities.submitRenewal'
                )
              "
              checkedValue="S"
              [disabled]="
                getValue(
                  'data.assistingPerson.responsibilities.letterOtherCommunication'
                ) === 'L'
              "
              label="{{ 'SUBMIT_RENEWAL_FORM2' | globalTranslate }}"
              class="label-section"
              (change)="onChange($event, 'S')"
            >
            </nh-checkbox>
          </div>
          } @if (appKey !== 'CHANGE_TEXT') {
          <div>
            <nh-checkbox
              name="submitRenewal"
              [control]="
                getControl(
                  'data.assistingPerson.responsibilities.submitRenewal'
                )
              "
              checkedValue="S"
              [disabled]="
                getValue(
                  'data.assistingPerson.responsibilities.letterOtherCommunication'
                ) === 'L'
              "
              label="{{ 'SUBMIT_RENEWAL_FORM' | globalTranslate }}"
              class="label-section"
              (change)="onChange($event, 'S')"
            >
            </nh-checkbox>
          </div>
          }
          <nh-checkbox
            name="letterOtherCommunication"
            [control]="
              getControl(
                'data.assistingPerson.responsibilities.letterOtherCommunication'
              )
            "
            checkedValue="L"
            [disabled]="
              getValue('data.assistingPerson.responsibilities.yourBehalf') ===
              'Y'
            "
            label="{{ 'LETTER_OTHER_COMMUNICATION' | globalTranslate }}"
            class="label-section"
            (change)="onChange($event, 'L')"
          >
          </nh-checkbox>
          <nh-checkbox
            name="yourBehalf"
            [control]="
              getControl('data.assistingPerson.responsibilities.yourBehalf')
            "
            checkedValue="Y"
            label="{{ 'YOUR_BEHALF' | globalTranslate }}"
            class="label-section"
            (change)="onChange($event, 'Y')"
          >
          </nh-checkbox>
          <ul class="list-inline form-check-label" style="padding-left: 2rem">
            <li>{{ "YOUR_BEHALF_1" | globalTranslate }}</li>
            <li>{{ "YOUR_BEHALF_2" | globalTranslate }}</li>
            <li>{{ "YOUR_BEHALF_3" | globalTranslate }}</li>
          </ul>
        </div>
        <div
          class="ps-5 pt-5 form-check-label"
          [innerHTML]="'REPRESENTATIVE_INDIVIDUAL' | globalTranslate"
        ></div>
        <ul class="ps-5 pb-5 list-inline form-check-label">
          <li>{{ "REPRESENTATIVE_INDIVIDUAL_1" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_INDIVIDUAL_2" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_INDIVIDUAL_3" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_INDIVIDUAL_4" | globalTranslate }}</li>
        </ul>
        <div
          class="ps-5 form-check-label"
          [innerHTML]="'REPRESENTATIVE_ORGANIZATION' | globalTranslate"
        ></div>
        <ul class="ps-5 pb-5 list-inline form-check-label">
          <li>{{ "REPRESENTATIVE_ORGANIZATION_1" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_ORGANIZATION_2" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_ORGANIZATION_3" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_ORGANIZATION_4" | globalTranslate }}</li>
          <li>{{ "REPRESENTATIVE_ORGANIZATION_5" | globalTranslate }}</li>
        </ul>
        <nh-alert
          type="warning"
          [isOpen]="
            getControl(
              'data.assistingPerson.responsibilities.letterOtherCommunication'
            )?.value === 'L' &&
            isFullCoverageApp &&
            !isAHS
          "
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{
                "AUTHREP_LETTER_OTHER_COMM_NOTICES" | globalTranslate
              }}</span>
            </div>
          </div>
        </nh-alert>
        <nh-alert
          type="warning"
          [isOpen]="
            this.showAssistingNotices ||
            (this.showAssistingNotices &&
              user === 'RP' &&
              appType === 'AFB' &&
              !isAHS)
          "
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{ "ASSISTING_PERSON_NOTICES" | globalTranslate }}</span>
            </div>
          </div>
        </nh-alert>
         <nh-alert
          type="warning"
          [isOpen]="
            getValue('data.assistingPerson.relationship').code === 'AR' &&
            (!getValue('data.assistingPerson.ackSignSw') ||
              !getValue('data.assistingPerson.assistingPersonSignName'))
          "
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{
                "RELATIONSHIP_AUTHREP_WARNING1" | globalTranslate
              }}</span>
            </div>
          </div>
        </nh-alert>
      </div>
      }
      <br />
    <!-- Checkbox and signature box in MP-AFB,RMB,RMC,  AHS-AFB, RMB, RMC,  PP-view tenncare RMB, RMC--->
      <div [formGroup]="getControl('data.assistingPerson')">
        @if ((((getValue('data.assistingOnBehalf').value === 'Assisting Person'
        || getValue('data.assistingOnBehalf').value === 'Persona que Ayuda' ) ||
        (getValue('data.addAssistingPersonToApp').value === 'Yes' ||
        getValue('data.addAssistingPersonToApp').value === 'Si' )) && (user !==
        'RP' || isAhsRmbOrRmc || ppViewTccHoHrmbrmc))) {
        <div>
          <h2 class="section-header">
              {{ "SIGNATURE_APPLICANT" | globalTranslate }} {{assistingPersonFullName}}
          </h2>
          <hr />
          @if (getValue('data.assistingPerson.relationship').code !== 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="{{ 'Assisting_Person_Checkbox' | globalTranslate }}"
              class="label-section"
            ></nh-checkbox>
          </div>
          } @if (getValue('data.assistingPerson.relationship').code === 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [disabled]="
                getValue('data.assistingPerson.assistingPersonSignName') ===
                  'Signature on file' ||
                getValue('data.assistingPerson.assistingPersonSignName') ===
                  'Firma en archivo'
                  ? true
                  : null
              "
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="{{
                'Assisting_Person_Auth_Rep_Checkbox' | globalTranslate
              }}"
              class="label-section"
            ></nh-checkbox>
          </div>
          }
          <div class="mt-custom">
            <nh-field
              id="hh_assistingPersonSignName"
              label="{{ 'SIGNATURE' | globalTranslate }}"
              class="label-section"
              [mandatory]="false"
              [attr.aria-required]="false"
            >
              <input
                type="text"
                class="form-control"
                name="assistingPersonSignName"
                formControlName="assistingPersonSignName"
                [attr.aria-label]="'SIGNATURE' | globalTranslate"
                [attr.aria-required]="errorMessage ? true : false"
                maxlength="93"
                [attr.disabled]="
                  getValue('data.assistingPerson.relationship').code === 'AR' &&
                  (getValue('data.assistingPerson.assistingPersonSignName') ===
                    'Signature on file' ||
                    getValue('data.assistingPerson.assistingPersonSignName') ===
                      'Firma en archivo')
                    ? true
                    : null
                "
              />
              @if (errorMessage) {
              <div class="error-messages position-relative">
                <span
                  class="form-text invalid-tooltip d-block"
                  role="alert"
                  aria-live="assertive"
                  >{{ "INVALID_ASSISTING_SIGN" | globalTranslate }}</span
                >
              </div>
              }
            </nh-field>
          </div>
        </div>
        }
      </div>
      <!-- Checkbox and signature box in FRM -->
      <div [formGroup]="getControl('data.assistingPerson')">
        @if ((( isY('data.ppAddAssistingPersonToApp')) ||
        isY('data.ppAssistingOnBehalf')) && (user === 'RP' &&
        this.isFinReassessment) ) {
          <h2 class="section-header">
              {{ "SIGNATURE_APPLICANT" | globalTranslate }} {{assistingPersonFullName}}
            </h2>
            <hr />
        <div>
          @if (getValue('data.assistingPerson.relationship').code !== 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="By checking this box and typing my name below, I am electronically signing as the Assisting Person."
              class="label-section"
            ></nh-checkbox>
          </div>
          } @if (getValue('data.assistingPerson.relationship').code === 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [disabled]="
                getValue('data.assistingPerson.relationship').code === 'AR' &&
                (getValue('data.assistingPerson.assistingPersonSignName') ===
                  'Signature on file' ||
                  getValue('data.assistingPerson.assistingPersonSignName') ===
                    'Firma en archivo')
                  ? true
                  : null
              "
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="{{
                'Assisting_Person_Auth_Rep_Checkbox' | globalTranslate
              }}"
              class="label-section"
            ></nh-checkbox>
          </div>
          }
          <div class="mt-custom">
            <nh-field
              id="hh_assistingPersonSignName"
              label="Signature:"
              class="label-section"
              [mandatory]="false"
              [attr.aria-required]="false"
            >
              <input
                type="text"
                class="form-control"
                name="assistingPersonSignName"
                formControlName="assistingPersonSignName"
                [attr.disabled]="
                  getValue('data.assistingPerson.relationship').code === 'AR' &&
                  (getValue('data.assistingPerson.assistingPersonSignName') ===
                    'Signature on file' ||
                    getValue('data.assistingPerson.assistingPersonSignName') ===
                      'Firma en archivo')
                    ? true
                    : null
                "
                aria-label="assistingPersonSignName"
                [attr.aria-required]="errorMessage ? true : false"
                maxlength="93"
              />
              @if (errorMessage) {
              <div class="error-messages position-relative">
                <span class="form-text invalid-tooltip d-block">{{
                  "INVALID_ASSISTING_SIGN" | globalTranslate
                }}</span>
              </div>
              }
            </nh-field>
          </div>
        </div>
        }
      </div>
      <!-- Checkbox and signature box in PP FC -->
      <div [formGroup]="getControl('data.assistingPerson')">
        @if (( isY('data.ppAddAssistingPersonToApp') ||
        isY('data.ppAssistingOnBehalf')) && (user === 'RP' && appType === 'AFB'
        && !isAHS) ) {
        <div>
          <h2 class="section-header">
              {{ "SIGNATURE_APPLICANT" | globalTranslate }} {{assistingPersonFullName}}
            </h2>
            <hr />
          @if (getValue('data.assistingPerson.relationship').code !== 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="By checking this box and typing my name below, I am electronically signing as the Assisting Person."
              class="label-section"
            ></nh-checkbox>
          </div>
          } @if (getValue('data.assistingPerson.relationship').code === 'AR') {
          <div>
            <nh-checkbox
              name="ackSignSw"
              [control]="getControl('data.assistingPerson.ackSignSw')"
              checkedValue="E"
              [ariaRequired]="errorMessage"
              label="{{
                'Assisting_Person_Auth_Rep_Checkbox' | globalTranslate
              }}"
              class="label-section"
            ></nh-checkbox>
          </div>
          }
          <div class="mt-custom">
            <nh-field
              id="hh_assistingPersonSignName"
              label="Signature:"
              class="label-section"
              [mandatory]="false"
              [attr.aria-required]="false"
            >
              <input
                type="text"
                class="form-control"
                name="assistingPersonSignName"
                formControlName="assistingPersonSignName"
                aria-label="Signature:"
                [attr.aria-required]="errorMessage ? true : false"
                maxlength="93"
              />
              @if (errorMessage) {
              <div class="error-messages position-relative">
                <span class="form-text invalid-tooltip d-block">{{
                  "INVALID_ASSISTING_SIGN" | globalTranslate
                }}</span>
              </div>
              }
            </nh-field>
          </div>
        </div>
        }
      </div>
    <!-- new checkbox and signature for Applicant/Member -->
    <div>
      @if ((getValue('data.assistingPerson.relationship')?.code === 'AR') &&
      (isY('data.addAssistingPersonToApp') ||
      (getValue('data.assistingOnBehalf')?.value === 'Assisting Person' ||
      getValue('data.assistingOnBehalf')?.value === 'Persona que Ayuda') ||
      isY('data.ppAddAssistingPersonToApp') || isY('data.ppAssistingOnBehalf')))
      {
      <div [formGroup]="getControl('data.assistingPerson')">
        <h2 class="section-header">
          {{ "SIGNATURE_APPLICANT" | globalTranslate }} {{fullName}}
        </h2>
        <hr />
        <div
          class="pt-3 form-check-label"
          [innerHTML]="'SIGNATURE_APPLICANT_1' | globalTranslate"
        ></div>
        <ul class="pb-3 list-inline form-check-label">
          <li>{{ "SIGNATURE_APPLICANT_2" | globalTranslate }}</li>
          <li>{{ "SIGNATURE_APPLICANT_3" | globalTranslate }}</li>
          <li>{{ "SIGNATURE_APPLICANT_4" | globalTranslate }}</li>
          <li>{{ "SIGNATURE_APPLICANT_5" | globalTranslate }}</li>
          <li>{{ "SIGNATURE_APPLICANT_6" | globalTranslate }}</li>
          <li>{{ "SIGNATURE_APPLICANT_7" | globalTranslate }}</li>
        </ul>
        <div>
          <nh-checkbox
            name="applicantAckSignSw"
            [control]="getControl('data.assistingPerson.applicantAckSignSw')"
            checkedValue="A"
            [mandatory]="true"
            label="{{ 'APPLICANT_CHECKBOX' | globalTranslate }}"
            class="label-section"
          ></nh-checkbox>
        </div>
        <div class="mt-custom">
          <nh-field
            id="hh_applicantSignName"
            label="{{ 'SIGNATURE' | globalTranslate }}"
            class="label-section"
          >
            <input
              type="text"
              class="form-control"
              name="applicantSignName"
              formControlName="applicantSignName"
              [attr.aria-label]="'SIGNATURE' | globalTranslate"
              maxlength="93"
              required
            />
          </nh-field>
        </div>
      </div>
      }
    </div>
        <nh-alert
          type="warning"
          [isOpen]="
            getValue('data.assistingPerson.relationship').code === 'AR' 
            && isAssistingPersonAndAckSignSwSame()"
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{
                "RELATIONSHIP_AUTHREP_WARNING" | globalTranslate
              }}</span>
            </div>
          </div>
        </nh-alert>
  </div>
</nh-form>